import { render } from "./Permis.vue?vue&type=template&id=a36684b0&scoped=true&ts=true"
import script from "./Permis.vue?vue&type=script&lang=ts"
export * from "./Permis.vue?vue&type=script&lang=ts"

import "./Permis.vue?vue&type=style&index=0&id=a36684b0&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36684b0"]])

export default __exports__